import router from "@/router/index";
import * as model from "@/model/prd/qualityMgt/selfTest/SelfTestPelletizingGri";
import {
  newEntityStoreHelper
} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
  var filter = Object.assign({}, paginationFilter, model.filter)
  return filter;
}

export default newEntityStoreHelper(() => new model.SelfTestPelletizingGri(), newFilter)
  .withStates({
    idReport: 2,
    baseModuleUrl: process.env.VUE_APP_PRODUCTION_API_URL + "production-service/prd",
    selfTestId: '',
  })
  .withMutations({
    setId(state, id) {
      state.selfTestId = id;
    }
  })
  .withActions({
    updateSelfTestId(context, id) {
      context.commit('setId', id); 
    },
    Save(context) {
      context.dispatch("api/put", {
        url: context.state.baseModuleUrl + "/" + "selfTestPelletizingGri",
        entity: context.state.entity,
        module: 'selfTestPelletizingGri'
      }, {
        root: true
      }).then(function () {
        context.dispatch("base/showSuccess", {
          userAlertSuccessStr: "Sucess!",
          dismissCountDown: 5,
          userAlertSuccessVisible: false,
        }, {
          root: true
        }).then(function () {
          router.push({
            path: '/prd/selfTestPelletizingGri',
            query: {
              id: context.state.selfTestId,
            }
          });
        })
      });

    },
    BackToList(context) {
      router.push({
        path: '/prd/selfTestPelletizingGri',
        query: {
          id: context.state.selfTestId,
        }
      });
    },
    Load(context, id) {
      context.dispatch("selfTestPelletizingGri/updateSelfTestId", id, {
        root: true
      });
      context.dispatch("api/get", {
          url: context.state.baseModuleUrl + "/selfTestPelletizingGri/findBySelfTestPelletizing/" + id
        }, {
          root: true
        })
        .then(response => {
          context.commit("selfTestPelletizingGri" + "/setRows", response, {
            root: true
          });

        });
    }
  })
  .buildStore()